import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

import { tpaColorName } from '../../../utils/color';

export type BadgeStylesParams = {
  badgeFont: StyleParamType.Font;
  badgeColor: StyleParamType.Color;
  badgeBackgroundColor: StyleParamType.Color;
  badgeBorderColor: StyleParamType.Color;
  badgeBorderWidth: StyleParamType.Number;
  badgeCornerRadiusTopLeft: StyleParamType.Number;
  badgeCornerRadiusTopRight: StyleParamType.Number;
  badgeCornerRadiusBottomLeft: StyleParamType.Number;
  badgeCornerRadiusBottomRight: StyleParamType.Number;
  badgeCornerRadiusLinked: StyleParamType.Number;
};

export const badgeStylesParams = createStylesParams<BadgeStylesParams>({
  badgeFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 14 }),
  },
  badgeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 1),
  },
  badgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(
      tpaColorName('wst-primary-background-color'),
      1,
    ),
  },
  badgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 0.1),
  },
  badgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  badgeCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  },
  badgeCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  },
  badgeCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  },
  badgeCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 20,
  },
  badgeCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
});
